
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.917 5.5c0-.911.221-1.745.664-2.5a5.167 5.167 0 011.836-1.836A4.991 4.991 0 018.917.5a4.99 4.99 0 012.5.664A5.167 5.167 0 0113.253 3c.442.755.664 1.589.664 2.5s-.222 1.745-.664 2.5a5.167 5.167 0 01-1.836 1.836 4.991 4.991 0 01-2.5.664 4.992 4.992 0 01-2.5-.664A5.167 5.167 0 014.58 8a4.853 4.853 0 01-.664-2.5zM.167 19.328c.052-1.953.729-3.594 2.031-4.922 1.328-1.302 2.969-1.979 4.922-2.031h3.594c1.953.052 3.593.73 4.921 2.031 1.303 1.328 1.98 2.969 2.032 4.922 0 .339-.117.612-.352.82-.208.235-.482.352-.82.352H1.339c-.339 0-.612-.117-.82-.352-.235-.208-.352-.481-.352-.82zm19.687-6.64v-2.5h-2.5c-.573-.053-.885-.365-.937-.938.052-.573.364-.885.937-.938h2.5v-2.5c.052-.572.365-.885.938-.937.573.052.885.365.937.938v2.5h2.5c.573.052.886.364.938.937-.052.573-.365.885-.938.938h-2.5v2.5c-.052.572-.364.885-.937.937-.573-.052-.886-.365-.938-.938z","fill":"#00DA5F"}})])
          )
        }
      }
    